<template>
  <section class="app-modal__section payment-plan-pay-modal__section--banks-compact">
    <div class="payment-plan-pay-modal__bank-extra">
      <button
        type="button"
        class="payment-plan-pay-modal__bank-extra-toggle"
        @click="expandedModel = !expandedModel"
      >
        <span>{{ text.payModal.banking.fields.banks }}</span>
        <i
          class="fa"
          :class="expandedModel ? 'fa-chevron-up' : 'fa-chevron-down'"
          aria-hidden="true"
        ></i>
      </button>

      <div v-if="expandedModel" class="payment-plan-pay-modal__bank-extra-content">
        <div class="app-modal__grid two-columns payment-plan-pay-modal__bank-grid payment-plan-pay-modal__bank-grid--two-columns">
          <label class="app-modal-field">
            <span>{{ text.payModal.banking.fields.beneficiaryBankRfc }}</span>
            <input
              v-model.trim="beneficiaryBankRfcModel"
              type="text"
              class="form-control"
              maxlength="13"
              autocomplete="off"
              :placeholder="text.payModal.banking.placeholders.beneficiaryBankRfc"
            />
          </label>

          <label class="app-modal-field">
            <span>{{ text.payModal.banking.fields.beneficiaryAccountNumber }}</span>
            <input
              v-model.trim="beneficiaryAccountNumberModel"
              type="text"
              class="form-control"
              maxlength="64"
              autocomplete="off"
              :placeholder="text.payModal.banking.placeholders.beneficiaryAccountNumber"
            />
          </label>
        </div>

        <div class="app-modal__grid two-columns payment-plan-pay-modal__bank-grid payment-plan-pay-modal__bank-grid--three-columns">
          <label class="app-modal-field">
            <span>{{ text.payModal.banking.fields.orderingBank }}</span>
            <input
              v-model.trim="orderingBankModel"
              type="text"
              class="form-control"
              maxlength="80"
              autocomplete="off"
              :placeholder="text.payModal.banking.placeholders.orderingBank"
            />
          </label>

          <label class="app-modal-field">
            <span>{{ text.payModal.banking.fields.orderingBankRfc }}</span>
            <input
              v-model.trim="orderingBankRfcModel"
              type="text"
              class="form-control"
              maxlength="13"
              autocomplete="off"
              :placeholder="text.payModal.banking.placeholders.orderingBankRfc"
            />
          </label>

          <label class="app-modal-field">
            <span>{{ text.payModal.banking.fields.orderingBankAccount }}</span>
            <input
              v-model.trim="orderingBankAccountModel"
              type="text"
              class="form-control"
              maxlength="64"
              autocomplete="off"
              :placeholder="text.payModal.banking.placeholders.orderingBankAccount"
            />
          </label>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PayModalSectionBanks',
  emits: [
    'update:expanded',
    'update:beneficiaryBankRfc',
    'update:beneficiaryAccountNumber',
    'update:orderingBank',
    'update:orderingBankRfc',
    'update:orderingBankAccount',
  ],
  props: {
    text: {
      type: Object,
      required: true,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    beneficiaryBankRfc: {
      type: String,
      default: '',
    },
    beneficiaryAccountNumber: {
      type: String,
      default: '',
    },
    orderingBank: {
      type: String,
      default: '',
    },
    orderingBankRfc: {
      type: String,
      default: '',
    },
    orderingBankAccount: {
      type: String,
      default: '',
    },
  },
  computed: {
    expandedModel: {
      get() {
        return this.expanded;
      },
      set(value) {
        this.$emit('update:expanded', !!value);
      },
    },
    beneficiaryBankRfcModel: {
      get() {
        return this.beneficiaryBankRfc;
      },
      set(value) {
        this.$emit('update:beneficiaryBankRfc', String(value || '').trim());
      },
    },
    beneficiaryAccountNumberModel: {
      get() {
        return this.beneficiaryAccountNumber;
      },
      set(value) {
        this.$emit('update:beneficiaryAccountNumber', String(value || '').trim());
      },
    },
    orderingBankModel: {
      get() {
        return this.orderingBank;
      },
      set(value) {
        this.$emit('update:orderingBank', String(value || '').trim());
      },
    },
    orderingBankRfcModel: {
      get() {
        return this.orderingBankRfc;
      },
      set(value) {
        this.$emit('update:orderingBankRfc', String(value || '').trim());
      },
    },
    orderingBankAccountModel: {
      get() {
        return this.orderingBankAccount;
      },
      set(value) {
        this.$emit('update:orderingBankAccount', String(value || '').trim());
      },
    },
  },
};
</script>
